import React from 'react';


const personPath = "M6.46 5.3C7.52 3.81 5.49 2.11 3.15 1.19 2.26 1.8 1.17 2.17 0 2.17 -1.17 2.17 -2.25 1.8 -3.14 1.19 -5.48 2.11 -7.52 3.81 -6.46 5.3 -4.62 7.9 4.62 7.9 6.46 5.3zM4.58 -3.18C4.58 -0.71 2.53 1.3 0 1.3 -2.52 1.3 -4.57 -0.71 -4.57 -3.18 -4.57 -5.65 -2.52 -7.65 0 -7.65 4.24 -7.63 4.58 -3.18 4.58 -3.18zM3.61 -6.58M-12.78 -12.21"

export const PersonSVG = ({className}: {className?: string}) => <svg className={className} xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 89 89" enableBackground="new 0 0 89 89">
  <g>
    <circle cx="47.524" cy="31.433" r="24.137" />
    <path d="M81.585,77.203c5.604-8.077-5.123-17.235-17.482-22.193c-4.693,3.311-10.41,5.264-16.578,5.264   c-6.176,0-11.898-1.958-16.596-5.275c-12.371,4.955-23.121,14.12-17.514,22.205C23.13,91.205,71.87,91.205,81.585,77.203z" />
  </g>
</svg>

export const personGoogleIcon = {
  path: personPath,
  fillColor: '#3f51b5',
  fillOpacity: 0.9,
  scale: 1.25,
  strokeWeight: 1,
  strokeColor: "#FFFFFF"
}

const groupPath = "M8.67 -0.98C8.67 -0.98 0.8 -8.68 0.8 -8.68 0.36 -9.11 -0.36 -9.11 -0.8 -8.68 -0.8 -8.68 -8.67 -0.98 -8.67 -0.98 -9.11 -0.55 -9.11 0.15 -8.67 0.58 -8.23 1.01 -7.52 1.01 -7.08 0.58 -7.08 0.58 -6.75 0.26 -6.75 0.26 -6.75 3.12 -6.75 5.55 -6.75 8.6 -6.75 8.6 -2.25 8.6 -2.25 8.6 -2.25 8.6 -2.25 2 -2.25 2 -2.25 2 2.25 2 2.25 2 2.25 2 2.25 8.6 2.25 8.6 2.25 8.6 6.75 8.6 6.75 8.6 6.75 5.55 6.75 3.12 6.75 0.26 6.75 0.26 7.08 0.58 7.08 0.58 7.3 0.79 7.59 0.9 7.88 0.9 8.16 0.9 8.45 0.79 8.67 0.58 9.11 0.15 9.11 -0.55 8.67 -0.98zM-2.95 13.58"

export const groupGoogleIcon = {
  path: groupPath,
  fillColor: "#588f27",
  fillOpacity: 0.9,
  scale: 1,
  strokeWeight: 1,
  strokeColor: "#FFFFFF",
}

export const GroupIconSVG = ({className}: {className?: string}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} version="1.1" x="0px" y="0px" viewBox="0 0 16 16">
  <g>
    <g>
      <path d="M15.707,7.293l-7-7c-0.391-0.391-1.023-0.391-1.414,0l-7,7c-0.391,0.391-0.391,1.023,0,1.414s1.023,0.391,1.414,0L2,8.414    C2,11.016,2,13.231,2,16h4v-6h4v6h4c0-2.769,0-4.984,0-7.586l0.293,0.293C14.488,8.902,14.744,9,15,9s0.512-0.098,0.707-0.293    C16.098,8.316,16.098,7.684,15.707,7.293z" />
    </g>
    <rect width="16" height="16" fill="none" />
  </g>
</svg>


export const arrowIcon = {
  path: "M-7.58 -20.04C-7.58 -20.04 0.019999999999999574 4.09 0.019999999999999574 4.09 0.019999999999999574 4.09 7.5 -20.09 7.5 -20.09 7.5 -20.09 -0.009999999999999787 -15.22 -0.009999999999999787 -15.22 -0.009999999999999787 -15.22 -7.58 -20.04 -7.58 -20.04zM21.990000000000002 -2.6799999999999997",
  fillColor: '#2b6a99',
  fillOpacity: 0.9,
  scale: 1,
  strokeWeight: 1,
  strokeColor: "#FFFFFF"
}

export const ArrowSVG = ({className}: {className?: string}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} version="1.1" x="0px" y="0px" viewBox="6 4 22 23">
  <g>
    <g>
      <path d="M 8.42,3.96 C 8.42,3.96 16.02,28.09 16.02,28.09 16.02,28.09 23.50,3.91 23.50,3.91 23.50,3.91 15.99,8.78 15.99,8.78 15.99,8.78 8.42,3.96 8.42,3.96 Z M 37.99,21.32"></path>
    </g>
  </g>
</svg>
